import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link, Icon } from '@resy/ui-kitchen';
import pinSVG from '../../../../../../../ui-kitchen/src/svg/icons/ic_location_20x20.svg';
import { handleMktAnalytics } from '../../AmexUtils';
import { CTA_EVENT_NAME } from '../../constants';

import './AmexCarouselEditorialCard.scss';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';

const AmexCarouselEditorialCard = (
  {
    blogData, position, blogLen, Analytics, matchMedia, showCity, taggingConfig,
  }
) => {
  const {
    title, id, imageLink, author, link, cityName,
  } = { ...blogData };

  const sanitizedTitle = sanitizeString(title);

  const renderCardContentFn = () => {
    let renderCardContent = '';
    const cardContent = (
      <div
        className={cx('AmexCarouselEditorialCard--wrapper', {
          paddingcard: position < blogLen - 1,
        })}
      >
        <div
          className="AmexCarouselEditorialCard--image"
          style={{
            backgroundImage: `url(${imageLink})`,
          }}
        />
        <h3
          className="AmexCarouselEditorialCard--blogtitle"
          dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
            __html: sanitizedTitle,
          }}
        />
        <p className="AmexCarouselEditorialCard--author">
          {author}
        </p>
        {(cityName && showCity) && (
          <p className="AmexCarouselEditorialCard--cityname">
            <Icon component={pinSVG} iconClass="pin" role="presentation" />
            {cityName}
          </p>
        )}
      </div>
    );

    const extraParams = {
      action_name: 'Editorial - Click',
      item_name: title,
    };

    if (link) {
      renderCardContent = (
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href={`${link}${taggingConfig?.utm ? taggingConfig?.utm : ''}`}
          key={id}
          onClick={() => handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParams)}
        >
          {cardContent}
        </Link>
      );
    } else {
      renderCardContent = cardContent;
    }
    return (
      renderCardContent
    );
  };

  const renderMobile = () => (
    <li className="AmexCarouselEditorialCard mobile-card">
      {renderCardContentFn()}
    </li>
  );

  const renderDesktop = () => (
    <div className="AmexCarouselEditorialCard">
      {renderCardContentFn()}
    </div>
  );

  return matchMedia.lg ? renderDesktop() : renderMobile();
};

AmexCarouselEditorialCard.defaultProps = {
  blogData: {},
  position: 0,
  blogLen: 0,
  showCity: true,
  taggingConfig: {
    utm: '',
  },
};

AmexCarouselEditorialCard.propTypes = {
  blogData: PropTypes.shape({
    id: PropTypes.number,
    imageLink: PropTypes.string,
    title: PropTypes.string,
    author: PropTypes.string,
    cityName: PropTypes.string,
    link: PropTypes.string,
  }),
  position: PropTypes.number,
  blogLen: PropTypes.number,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  taggingConfig: PropTypes.shape({
    utm: PropTypes.string,
  }),
};

export default AmexCarouselEditorialCard;
